import { BidStatus } from '@b-stock/fe-core/bstock-next/queries'
import { usePollUntil } from '@b-stock/fe-core/pay-ui'

import buyerOrderByListingIdQuery from '@/buyer-portal/queries/buyerOrderByListingIdQuery'

const hasOrderForWon = (
  response: ReturnType<typeof buyerOrderByListingIdQuery.useWithOpts>
) => !!response.data

const useOrderForWon = (
  listingId: string,
  bidState: BidStatus,
  isContract: boolean = false
) => {
  const {
    data: order,
    isSuccess: isOrderSuccess,
    refetch: refetchOrder,
  } = buyerOrderByListingIdQuery.useWithOpts([listingId, bidState], {
    enabled: bidState === BidStatus.WON && !isContract,
  })

  // If we've attempted to lookup an order, but didn't get one, poll every 5s
  usePollUntil(
    refetchOrder,
    hasOrderForWon,
    5000,
    !isContract && isOrderSuccess && !order
  )

  return order
}

export default useOrderForWon
